import React from 'react';

// Clean, bright corporate backdrop. Fixed behind all content.
export default function BackgroundFX() {
  return (
    <div className="fixed inset-0 -z-10 pointer-events-none" aria-hidden>
      <div className="absolute inset-0 bg-[#f8fafc]" />
      <div className="absolute inset-0 bg-[radial-gradient(60%_45%_at_85%_-5%,rgba(37,99,235,0.08),transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(45%_40%_at_-5%_10%,rgba(37,99,235,0.05),transparent_60%)]" />
      <div className="absolute inset-0 grid-bg opacity-60" />
    </div>
  );
}
